import React from "react";
import { T } from "../app/tokens.js";

export function IdentityMatchHint({ value }) {
  if (!value) return null;
  return (
    <span data-testid="identity-match-hint" title={`matched: ${value}`}
      style={{ display: "block", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis",
        whiteSpace: "nowrap", color: T.mid, fontSize: T.fsXxxs5, lineHeight: "14px", fontWeight: T.fwNormal }}>
      matched: {value}
    </span>
  );
}
